export default __webpack_public_path__ + "assets/images/0fc7a1f874557d38e0d26be11910e95e.png";